import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import Toast from "../helpers/Toast";
import { AssistanceService } from "../services/AssistanceService";
import ButtonComponent from "./ButtonComponent";
import { useIntl } from "react-intl";
import { CreateFabricationDTO } from "../models/Fabrication/CreateFabricationDTO";
import InputComponent from "./InputComponent";
import { AssistanceDTO } from "../models/Assistance/AssistanceDTO";
import { useParams } from "react-router-dom";
import { PartService } from "../services/PartService";
import SearchSelectComponent, { SelectItemsProps } from "./SearchSelectComponent";
import { PartDTO } from "../models/Parts/PartDTO";
import { useAvailableModulesContext } from "../context/AvailableModulesContext";


export type FabricationComponentProps = {
    close: () => void;
    onAdded: () => void;
    AssistanceId: number;

    IsOpen: boolean;
};

export default function FabricationComponent(props: FabricationComponentProps) {
    const assistanceService = new AssistanceService();
    const partService = new PartService();

    const [loadingInsert, setLoadingInsert] = useState<boolean>(false);

    //remover erro consola do react sobre compoente rendirizável
    const [fabrication, setFabrication] = useState<CreateFabricationDTO>({
        assistanceId: 0,
        assistanceDocType: null,
        assistanceDocSerie: null,
        assistanceDocNumber: null,
        reference: "",
        numSerie: undefined,
        description: "",
        quantity: 1,
        unitPrice: 0,
        totalLinePrice: 0,
        warehouse: 1,
    });

    const [isLoadingFabrication, setIsLoadingFabrication] = useState<boolean>(false);
    const [isLoadingAssistance, setIsLoadingAssistance] = useState<boolean>(false);
    const [assistance, setAssistance] = useState<AssistanceDTO>({} as AssistanceDTO);
    const [reload, setReload] = useState<boolean>(false);
    const { id } = useParams<{ id: string }>();

    //Obter preço de custo total (peças+horas)
    const [isLoadingAssistancePartsAndHoursTotalPrice, setIsLoadingAssistancePartsAndHoursTotalPrice] = useState<boolean>(false);

    //Obter valor setting numero de serie da fabricação
    const [isActiveFabricationNumSerie, setIsActiveFabricationNumSerie] = useState<boolean>(false);

    const { availableModules } = useAvailableModulesContext();
    useEffect(() => {
        if (availableModules.includes("FabricationSage50cIsActiveNumSerie")) {
            setIsActiveFabricationNumSerie(true);
        }
    },[props.IsOpen]);
    
    useEffect(() => {
        const getAssistance = async () => {
            setIsLoadingAssistance(true);

            var response = await assistanceService.GetById(Number(id));
            if (response.success === false || response.obj == null) {
                setIsLoadingAssistance(false);
                Toast.Show("error", response.message);
                return;
            }
            setAssistance(response.obj);
            setIsLoadingAssistance(false);
        };

        getAssistance();
    }, [reload]);


    //autocomplete para referencia
    const [partSelected, setPartSelected] =
        useState<SelectItemsProps | null>(null);

    const GetPart = async (
        value: string
    ): Promise<SelectItemsProps[]> => {
        var data: PartDTO = {
            erpId: value,
            name: ""
        };

        var response = await partService.GetByReference(data);
        if (response.success === false || response.obj === null) {
            Toast.Show("error", response.message);
            return [];
        }

        const list: SelectItemsProps[] = [];

        response.obj.forEach((element) => {
            var item: SelectItemsProps = {
                value: element.name,
                label: element.erpId,
            };
            list.push(item);
        });

        return list;
    };

    const createFabrication = async (): Promise<boolean> => {

        // Se o valor do numSerie não for alterado pelo user, usamos o numSerie do equipamento
        // estava a mandar "", se nao alterassemos
        const numSerieToSend = fabrication.numSerie !== undefined ? fabrication.numSerie : assistance.equipment?.serialNumber || "";

        var data: CreateFabricationDTO = {
            assistanceId: props.AssistanceId,
            assistanceDocType: assistance.erpDocType,
            assistanceDocSerie: assistance.erpSerie,
            assistanceDocNumber: assistance.erpNumDoc,
            reference: partSelected?.label ?? "",
            numSerie: numSerieToSend,
            description: fabrication.description,
            quantity: fabrication.quantity ?? 1,
            unitPrice: fabrication.unitPrice ?? 0,
            totalLinePrice: fabrication.totalLinePrice ?? 0,
            warehouse: fabrication.warehouse ?? 1,
        };

        // campos obrigatorios

        if (partSelected?.label === undefined || partSelected?.label === "") {
            Toast.Show("error", "Indique a referência.");
            return false;
        }
        if (fabrication.unitPrice < 0) {
            Toast.Show("error", "O preço não pode ser menor que zero.");
            return false;
        }

        var response = await assistanceService.CreateFabrication(data);
        if (response.success === false) {
            Toast.Show("error", response.message);
            return false;
        }

        props.onAdded();
        Toast.Show("success", response.message);
        return true;
    };

    const addFabricationClick = async () => {
        setLoadingInsert(true);
        var responseAdd = await createFabrication();
        setLoadingInsert(false);
        if (responseAdd === true) {
            props.close();
        }
    };

    useEffect(() => {
        const fetchPartsTotalPrice = async () => {
            setIsLoadingAssistancePartsAndHoursTotalPrice(true);

            // Obter o preço total das peças
            var responsePartsTotalPrice = await partService.GetPartsAndHoursTotalPrice(Number(id));

            if (responsePartsTotalPrice.success === false || responsePartsTotalPrice.obj == null) {
                Toast.Show("error", responsePartsTotalPrice.message);
                setIsLoadingAssistancePartsAndHoursTotalPrice(false);
                return;
            }

            // Atualizar o preço unitário diretamente no estado fabrication
            setFabrication((prevFabrication) => ({
                ...prevFabrication,
                unitPrice: responsePartsTotalPrice.obj ?? 0,
            }));

            setIsLoadingAssistancePartsAndHoursTotalPrice(false);
        };

        // Chamar a função do preço total das peças ao abrir o popup
        fetchPartsTotalPrice();
    }, [props.IsOpen, id]);


    const intl = useIntl();

    return (
        <Dialog open={props.IsOpen}>
            <DialogTitle>{"Fabricar Artigo"}</DialogTitle>
            <DialogContent>
                <Row style={{ margin: "0px", padding: "0px" }}>
                    <InputComponent
                        xl={6}
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        style={{ width: "100%" }}
                        type={"text"}
                        value={`${assistance.erpDocType} ${assistance.erpSerie} ${assistance.erpNumDoc}`}
                        label={"Assistência"}
                        readOnly={true}
                        showLoadingSkeleton={isLoadingFabrication}
                    />
                </Row>
                <Row style={{ margin: "0px", padding: "0px" }}>
                    <SearchSelectComponent
                        xl={12}
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        label={"Referência"}
                        loadOptions={GetPart}
                        onChange={(e) => {
                            setPartSelected(e);
                        }}
                        value={partSelected}
                        style={{ width: "100%" }}
                    />
                </Row>
                <Row style={{ margin: "0px", padding: "0px" }}>
                    {isActiveFabricationNumSerie
                        && (
                            <InputComponent
                                xl={6}
                                lg={6}
                                md={6}
                                sm={6}
                                xs={6}
                                style={{ width: "100%" }}
                                type={"text"}
                                //mostrar numSerie do equipamento por defeito, se alterarmos o valor do input, mandamos novo valor
                                value={fabrication.numSerie !== undefined ? fabrication.numSerie : assistance.equipment?.serialNumber}
                                label={"Número de Série"}
                                readOnly={false}
                                showLoadingSkeleton={isLoadingFabrication}
                                onChange={(t: string) => {
                                    setFabrication({ ...fabrication!, numSerie: t });
                                }}
                            />
                        )
                    }
                </Row>
                <Row style={{ margin: "0px", padding: "0px" }}>
                    <InputComponent
                        xl={12}
                        lg={12}
                        md={12}
                        sm={12}
                        xs={12}
                        style={{ width: "100%" }}
                        type={"text"}
                        value={partSelected?.value ?? ""}
                        label={"Descrição"}
                        readOnly={false}
                        showLoadingSkeleton={isLoadingFabrication}
                        onChange={(t: string) => {
                            setFabrication({ ...fabrication!, description: t });
                        }}
                    />
                </Row>
                <Row style={{ margin: "0px", padding: "0px" }}>
                    <InputComponent
                        xl={6}
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        style={{ width: "100%" }}
                        type={"number"}
                        value={1}
                        label={"Quantidade"}
                        readOnly={true}
                        showLoadingSkeleton={isLoadingFabrication}
                    />
                    <InputComponent
                        xl={6}
                        lg={6}
                        md={6}
                        sm={6}
                        xs={6}
                        style={{ width: "100%" }}
                        type={"number"}
                        value={fabrication.unitPrice ?? 0}
                        label={"Preço de Custo"}
                        readOnly={false}
                        showLoadingSkeleton={isLoadingAssistancePartsAndHoursTotalPrice}
                        onChange={(t: number) => {
                            setFabrication({ ...fabrication!, unitPrice: t });
                        }}
                    />
                </Row>
            </DialogContent>
            <DialogActions className="loginbuttons">
                <div style={{ display: "flex", justifyContent: "space-between", margin: "10px", paddingLeft: "5px" }}>
                    <Col md={6} sm={6} xs={6} lg={6}>
                        <ButtonComponent
                            onClick={addFabricationClick}
                            className="enteraccount"
                            style={{ width: "97%", borderRadius: "5px" }}
                            text={intl.formatMessage({ id: "FabricationComponent.Create" })}
                            loading={loadingInsert}
                        />
                    </Col>
                    <Col md={6} sm={6} xs={6} lg={6}>
                        <ButtonComponent
                            onClick={props.close}
                            className="enteraccount"
                            style={{ width: "97%", borderRadius: "5px" }}
                            text={intl.formatMessage({ id: "FabricationComponent.Cancel" })}
                            loading={loadingInsert}
                        />
                    </Col>
                </div>
            </DialogActions>
        </Dialog>
    );
}
